export const congrats = {
  me: {
    images: `./img/congrats/tiger.png`,
    text: `Большая новогодняя распродажа AMAZFIT!`,
  },
  friend: {
    images: `./img/congrats/tiger.png`,
    text: `Большая новогодняя распродажа AMAZFIT!`,
  },
  family: {
    images: `./img/congrats/tiger.png`,
    text: `Большая новогодняя распродажа AMAZFIT!`,
  },
  favorite: {
    images: `./img/congrats/tiger.png`,
    text: `Большая новогодняя распродажа AMAZFIT!`,
  },
};
